import { a as __rest } from '../../_tslib.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { twMerge } from 'tailwind-merge';
import baseInputStyles from './BaseInput.styles.esm.js';

/**
 * The BaseInput component shows an Input
 */
const BaseInput = React__default.forwardRef((_a, ref) => {
  var {
      className = "",
      disabled = false,
      inverse = false
    } = _a,
    props = __rest(_a, ["className", "disabled", "inverse"]);
  // Generate the input classes
  const classes = twMerge(baseInputStyles({
    inverse
    // class: className,
  }), className);
  return jsx("input", Object.assign({
    ref: ref,
    className: classes,
    "aria-disabled": disabled,
    disabled: disabled
  }, props));
});
BaseInput.displayName = "BaseInput";

export { BaseInput };
